import { observable } from 'mobx';
import { query, serviceQueries } from '@estee/elc-service-bus';
import { IProduct } from '~api/IProduct';
import { Product } from '~domain/entities/Product';
import { Config } from '~domain/entities/Config';
import { mapProductSkusById } from '../../utils/dataAggregator';
import { ProductQueryProps } from '~constants/ProductQueryProps';

export interface IProductSkuMap {
    [skuId: string]: IProduct;
}

export class ProductRepository {
    @observable public product: Product;
    @observable public configService: Config;

    constructor(config: Config) {
        this.configService = config;
    }

    public loadSkuById = async (skuId: string) => {
        const data = await query(serviceQueries.GET_PRODUCT_DATA, {
            filterBy: { skus: { skuIds: [skuId] } },
            query: ProductQueryProps
        });
        const skuIdMap: IProductSkuMap = (data as []).reduce(mapProductSkusById, {});
        const productInfo = skuIdMap[skuId];

        if (productInfo) {
            this.product = this.toProduct(productInfo);
        }

        return this.product;
    };

    private toProduct(data: IProduct) {
        const { currency } = this.configService.config;
        const priceByCurrency = (data.prices || []).find((price) => price.currency === currency);

        return new Product({
            skuId: data.skuId,
            name: data.displayName,
            imageUrl: data.media.small[0].src,
            productId: data.productId,
            size: data.sizes[0].value,
            formattedPrice: priceByCurrency ? priceByCurrency.priceFormatted : ''
        });
    }
}
